import { Fragment } from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import BaseTags from '@base/Tags/Tags';
import { Spacings } from '@styles/index';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getGoalUId } from '@selectors/quizTaking';
import { getIsGTPGoal } from '@api/selectors/constants';
import useConstants from '@api/hooks/useConstants';
import useProgramme from '../../../Common/useProgramme';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85px;
  margin-top: ${Spacings.SPACING_9B};
`;

const StyledH6 = styled(H6)`
  color: var(--color-i-gray);
`;

const Tags = () => {
  const { isFree } = useProgramme();
  const {
    query: { quizUID }
  } = useRouter();

  const goalUID = useSelectorWithShallowEqual(getGoalUId(quizUID));

  const isGTP = useConstants(getIsGTPGoal(goalUID));

  const getItems = () => {
    const items = [];

    if (isGTP) {
      if (isFree) {
        items.push(
          <Fragment key="free-tag">
            <BaseTags type="filled" bgColor="var(--color-text-secondary)">
              FREE
            </BaseTags>
            <StyledH6>Test</StyledH6>
          </Fragment>
        );
      } else {
        items.push(
          <Fragment key="plus-tag">
            <BaseTags type="filled" bgColor="var(--color-text-secondary)">
              PLUS
            </BaseTags>
            <StyledH6>Test</StyledH6>
          </Fragment>
        );
      }
    } else if (isFree) {
      items.push(
        <Fragment key="free-tag">
          <BaseTags type="filled" bgColor="var(--color-text-secondary)">
            Free
          </BaseTags>
          <StyledH6>Test</StyledH6>
        </Fragment>
      );
    }

    return items;
  };

  const tagsToRender = getItems();

  if (!tagsToRender.length) {
    return null;
  }

  return <Wrapper>{tagsToRender}</Wrapper>;
};

export default Tags;
